<template>
  <div>
    <img alt="Leadtributor logo" src="../assets/leadtributor-logo-text.png" width="500">

    <v-row justify="center">
      <v-col cols="12">
        <LoginComponent v-model="loginModel" @login="onLogin">
          <a>Passwort vergessen?</a>
          <a>Datenschutz</a>
          <a>AGB</a>
        </LoginComponent>
      </v-col>
      <v-col>
        {{ loginModel }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LoginComponent from "@/components/login/LoginComponent";
import {reactive} from "@vue/composition-api";
export default {
  name: "LoginView",
  components: {LoginComponent},
  setup(){
    const loginModel = reactive({
      login: '',
      password: '',
      failedLogin: false
    })

    function onLogin (loginData) {
      console.log(loginData.login, loginData.password)
      loginData.failedLogin = true
    }

    return {loginModel, onLogin}
  }
}
</script>

<style scoped>

</style>
